__turbopack_context__.v({
  "CTA": "Button-module-scss-module__HB5Z3q__CTA",
  "FAB": "Button-module-scss-module__HB5Z3q__FAB",
  "btn": "Button-module-scss-module__HB5Z3q__btn",
  "contained": "Button-module-scss-module__HB5Z3q__contained",
  "danger": "Button-module-scss-module__HB5Z3q__danger",
  "hug": "Button-module-scss-module__HB5Z3q__hug",
  "icon": "Button-module-scss-module__HB5Z3q__icon",
  "outlined": "Button-module-scss-module__HB5Z3q__outlined",
  "outlinedDisabled": "Button-module-scss-module__HB5Z3q__outlinedDisabled",
  "primary": "Button-module-scss-module__HB5Z3q__primary",
  "raised": "Button-module-scss-module__HB5Z3q__raised",
  "secondaryCTA": "Button-module-scss-module__HB5Z3q__secondaryCTA",
  "small": "Button-module-scss-module__HB5Z3q__small",
  "specialSmallSidePadding": "Button-module-scss-module__HB5Z3q__specialSmallSidePadding",
  "startIcon": "Button-module-scss-module__HB5Z3q__startIcon",
  "success": "Button-module-scss-module__HB5Z3q__success",
  "text": "Button-module-scss-module__HB5Z3q__text",
  "textNoHover": "Button-module-scss-module__HB5Z3q__textNoHover",
  "underlined": "Button-module-scss-module__HB5Z3q__underlined",
  "uppercase": "Button-module-scss-module__HB5Z3q__uppercase",
  "warning": "Button-module-scss-module__HB5Z3q__warning",
});
